import React, { useState } from "react";
import { Modal, Input } from "antd";
import dayjs from "dayjs";

import useCreate from "hooks/useCreate";
import TaskColorPicker from "components/TaskColorPicker";
import InputDate from "components/InputDate";
import range from "helpers/range";

const disabledDateTime = () => ({
  disabledMinutes: () => [
    ...range(1, 15),
    ...range(16, 30),
    ...range(31, 45),
    ...range(46, 60),
  ],
});

const AddTask = ({ date: default_date, handleClose, refetch }) => {
  const [content, setContent] = useState("");
  const [status_color, setStatusColor] = useState("red");
  const [date, setDate] = useState(default_date);

  const { is_saving, create } = useCreate({
    path: "/tasks",
    onSuccess: refetch,
  });

  const handleOk = async () => {
    try {
      await create({
        status_color,
        content,
        date,
      });
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      style={{ top: 45 }}
      maskClosable={false}
      width={700}
      title="Dodaj priorytet"
      open={true}
      onOk={handleOk}
      onCancel={handleClose}
      cancelText="Anuluj"
      okText="Dodaj"
      okButtonProps={{
        disabled: !content || !date || is_saving,
        loading: is_saving,
      }}
    >
      <Input.TextArea
        value={content}
        style={{ marginBottom: 30 }}
        onChange={({ target: { value } }) => setContent(value)}
        rows={7}
        maxLength={400}
        showCount={true}
      />
      <InputDate
        format="DD-MM-YYYY HH:mm"
        showTime={{ format: "HH:mm" }}
        disabledTime={disabledDateTime}
        defaultValue={dayjs(date)}
        onChange={(a) => setDate(a)}
        style={{ marginBottom: 20 }}

      />
      <TaskColorPicker active_color={status_color} setColor={setStatusColor} />
    </Modal>
  );
};

export default AddTask;
